import { render, staticRenderFns } from "./PopupFilter.vue?vue&type=template&id=b2defc92&scoped=true"
import script from "./PopupFilter.vue?vue&type=script&lang=js"
export * from "./PopupFilter.vue?vue&type=script&lang=js"
import style0 from "./PopupFilter.vue?vue&type=style&index=0&id=b2defc92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2defc92",
  null
  
)

export default component.exports